import { motion } from 'framer-motion';
import SectionDivider from './SectionDivider';

/**
 * Trust strip, rebuilt as a citation index rather than three centered
 * columns of floating text. This is legal-basis content — actual statutes
 * — so it now reads like one: a docket-row header (same family as How It
 * Works/Features/Guides) followed by a left-aligned, full-width list of
 * citations, each a row with a section-number chip, the statute name, and
 * what it actually guarantees — closer to a citation index in a real brief
 * than a marketing "trust badges" row.
 */

const CITATIONS = [
  {
    section: '§5',
    statute: 'Information Technology Act, 2000',
    guarantee: 'An electronic signature carries the same legal weight as a wet-ink one.',
  },
  {
    section: '§63',
    statute: 'Bharatiya Sakshya Adhiniyam, 2023',
    guarantee: 'Every dispute is backed by an evidence certificate courts already recognize.',
  },
  {
    section: '§18',
    statute: 'MSMED Act, 2006',
    guarantee: 'Udyam-registered freelancers get a faster recovery route — no court fee.',
  },
] as const;

export default function TrustStripRevamp() {
  return (
    <>
      <SectionDivider />
      <section className="relative bg-black py-16 md:py-20">
        <div className="px-6 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="mb-10 md:mb-12"
          >
            {/* <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-[11px] tracking-[0.3em] text-[#3cb44f]/80 uppercase shrink-0">
                Legal basis
              </span>
              <span className="h-px flex-1 bg-white/10" />
              <span className="font-mono text-[11px] tracking-[0.2em] text-white/30 uppercase shrink-0">
                03 statutes
              </span>
            </div> */}
            <h2 className="font-bricolage font-extrabold text-2xl md:text-4xl text-white leading-[1.2] tracking-tight text-left">
              Not just a template generator. Every contract is grounded in real{' '}
              <span className="font-instrumentserif italic font-normal text-accent">Indian law</span>, not house
              style.
            </h2>
          </motion.div>

          <div className="divide-y divide-white/10 border-t border-b border-white/10">
            {CITATIONS.map((citation, i) => (
              <motion.div
                key={citation.section}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="flex flex-col md:flex-row md:items-center gap-3 md:gap-8 py-6"
              >
                <div className="flex items-center gap-3 md:w-64 shrink-0">
                  <span className="font-mono text-[13px] text-[#3cb44f] font-semibold">{citation.section}</span>
                  <span className="text-[14px] text-white font-semibold">{citation.statute}</span>
                </div>
                <p className="text-[13.5px] text-white/55 leading-relaxed">{citation.guarantee}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
